import { createSelector } from 'reselect';

import { isItemPreview } from 'utils/isItemPreview';
import getActivePagination from './getActivePagination';
import getMatch, { getContentType } from './getMatch';
import getContentArchive from './getContentArchiveBase';
import { createGetContentItemBySlug } from './createGetContentItem';
import { getRelatedContentItemsByItem } from './relatedItemSelectors';

const getActiveContentItemBySlug = createSelector(
  [getContentType],
  (contentType) => createGetContentItemBySlug(contentType),
);

const getActiveContentItem = createSelector(
  [
    getActiveContentItemBySlug,
    // This sucks for memoization, but getItem for now is made in a way that doesn't get better than that
    (state) => state,
  ],
  (getItem, state) => getItem(state),
);

const getActiveContentItemRelatedItems = createSelector(
  [
    getActiveContentItem,
    (state) => state,
  ],
  (contentItem, state) => getRelatedContentItemsByItem(state, contentItem),
);

const hasFetchedArchiveContent = createSelector(
  [
    getActivePagination,
    getContentArchive,
  ],
  (pagination, { pages = {} } = {}) => !!pages[pagination.currentPage],
);

const hasFetchedContentItem = createSelector(
  [getActiveContentItem, getActiveContentItemRelatedItems],
  // preview items don't have related items
  (contentItem, relatedItems) =>
    !!contentItem && (0 < relatedItems.relatedPosts.length || isItemPreview(contentItem)),
);

const hasFetchedActiveContent = createSelector(
  [
    getMatch,
    hasFetchedArchiveContent,
    hasFetchedContentItem,
  ],
  ({ isArchive }, hasFetchedArchive, hasFetchedItem) =>
    (isArchive ? hasFetchedArchive : hasFetchedItem),
);

export default hasFetchedActiveContent;
